import { useQuery } from "@apollo/client";
import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { GET_ACTIVE_USER } from "../../queries/auth.queries";
import Loader from "../common/loader/loader.component";
import AccountAddresses from "./account-addresses/account-addresses.component";
import AccountBankCards from "./account-bank-cards/account-bank-cards.component";
import AccountMenu from "./account-menu/account-menu.component";
import AccountOrders from "./account-orders/account-orders.component";
import AccountSettings from "./account-settings/account-settings.component";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles({
  container: {
    paddingTop: 144,
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 120,
  },
  menu: {
    width: "15%",
    "@media (max-width:940px)": {
      display: "none",
    },
  },
  page: {
    width: "80%",
    "@media (max-width:940px)": {
      width: "100%",
    },
  },
});

const pages = {
  Orders: <AccountOrders />,
  Addresses: <AccountAddresses />,
  "Bank Cards": <AccountBankCards />,
  Settings: <AccountSettings />,
};

const Account = () => {
  const classes = useStyles();
  const location = useLocation();
  const [page, setPage] = useState("Orders");

  const setCurrentPage = (p) => {
    setPage(p);
  };

  const history = useHistory();
  const state = location?.state;

  useEffect(() => {
    setPage(state?.page);
  }, [state]);

  useEffect(() => {
    setPage("Orders");
  }, []);

  const { loading: userLoading, data: userData } = useQuery(GET_ACTIVE_USER);

  if (userLoading) {
    return (
      <div
        style={{ height: "100vh", display: "flex", justifyContent: "center" }}
      >
        <Loader color={"#B73232"} size={50} />
      </div>
    );
  }

  if (userData && !userData.activeCustomer) {
    history.push("/");
  }

  const currentPage = pages[page];

  return (
    <div className={classes.container}>
      <div className={classes.menu}>
        <AccountMenu setCurrentPage={setCurrentPage} />
      </div>
      <div className={classes.page}>{currentPage}</div>
    </div>
  );
};

export default Account;
